import gql from 'graphql-tag'
export default gql`
  mutation updateSearchVariableFilters ($key: String!, $value: SearchVariableFilters!) {
    updateSearchVariableFilters(key: $key, value: $value) @client
  }
`
